import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { swing } from 'react-animations';
import { StyleSheet, css } from 'aphrodite';
import globalStyles from '../../styles';
import logoIcon from '../../assets/images/logo black.png';

class Loading extends Component {
    render() {
        if (!this.props.loading) {
            return null;
        }

        return (
            <div className={css(globalStyles.flex, styles.container)}>
                <img src={logoIcon} alt="" width="auto" height="50%" className={css(styles.swing)} />
            </div>
        );
    }
}

Loading.propTypes = {
    loading: PropTypes.bool,
};

const styles = StyleSheet.create({
    container: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(200, 200, 200, 0.3)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    swing: {
        animationName: swing,
        animationDuration: '2s',
        animationIterationCount: 'infinite',
    },
});

const mapStateToProps = (state) => {
    const { loading } = state;

    return { loading };
};

export default connect(mapStateToProps)(Loading);
